export default "__VITE_ASSET__4b23d452__"